import React from 'react';
import PropTypes from 'prop-types';

export default class Description extends React.PureComponent {
    static propTypes = {
        description: PropTypes.string,
        image_src: PropTypes.string,
    };

    render() {
        const { description, image_src } = this.props;
        return (
            <div>
                {description && (
                    <span
                        dangerouslySetInnerHTML={{ __html: description }}
                        className="m2g-product-editor-product-description--alternate m2g-product-editor-product-description--above"
                    />
                )}
                {(image_src || description) && (
                    <div className="m2g-product-editor-product-info">
                        {image_src && (
                            <div className="m2g-product-editor-product-image-container">
                                <img
                                    className="m2g-product-editor-product-image m2g-image"
                                    src={image_src}
                                />
                            </div>
                        )}
                        <span
                            dangerouslySetInnerHTML={{ __html: description }}
                            className="m2g-product-editor-product-description"
                        />
                    </div>
                )}
                {description && (
                    <span
                        dangerouslySetInnerHTML={{ __html: description }}
                        className="m2g-product-editor-product-description--alternate m2g-product-editor-product-description--below"
                    />
                )}
            </div>
        );
    }
}
